import {Selector} from '@ngxs/store';
import {DashboardState} from '@store/dashboard/dashboard.state';
import {DashboardStateModel} from '@store/dashboard/dashboard-state.model';
import {IMetricsDevices, IMetricsStorage} from '@interfaces/metrics';
import {IOfflineDevicesSummary} from '@interfaces/analytics';

export class DashboardSelectors {
  @Selector([DashboardState])
  static getStorageMetrics(state: DashboardStateModel): IMetricsStorage | null {
    return state.storage;
  }

  @Selector([DashboardState])
  static getDevicesMetrics(state: DashboardStateModel): IMetricsDevices | null {
    return state.devices;
  }

  @Selector([DashboardState])
  static getOfflineDevicesSummary(state: DashboardStateModel): IOfflineDevicesSummary | null {
    return state.offlineDevicesSummary;
  }
}
